<template>
    <div class="w-full truncate">
        <div class="inline text-blue-500 truncate">{{ permission.name }}
            <span v-if="permission.actions.length"
                  class="text-gray-400 text-xs">(+{{ permission.actions.join(', +') }})</span>
        </div>
        <div class="inline text-gray-500 text-xs truncate" v-if="packageReference && packageReference.length">Packages -
            <span class="text-orange-400 font-bold"
                  v-if="packageReference.some((i) => i.packageReference === '*')">ALL</span>
            <div class="inline text-gray-500 text-xs truncate">
                <template v-for="pp in packageReference.filter((i) => i.packageReference!=='*')">
                    <span class="font-bold" v-text="pp.packageReference"></span>,
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        permission: Object,
    },
    data() {
        return {}
    },
    watch: {},
    computed: {
        packageReference() {
            return this.permission.scopes.packageReference ? this.permission.scopes.packageReference : []
        },
    },
    methods: {},
    async mounted() {
    }
}
</script>
